<template>
  {{ $t('branch.place.list') }} <TagIcon class="w-4 h-4 ml-2 mr-2" />
  <LoadingIcon icon="three-dots" class="w-8 h-8" v-show="loading" />
  <ul v-show="!loading">
    <template v-for="branchPlace in branchPlaces" :key="branchPlace.uuid">
      <li v-if="this.selectedBranchPlaces.includes(branchPlace.uuid)">
        <router-link
          :to="{
            name: 'side-menu-branch-places-detail',
            params: { branchUUID: branchPlace.branch.uuid, uuid: branchPlace.uuid }
          }"
          tag="a"
        >
          <ArrowUpLeftIcon class="w-4 h-4 mr-1 ml-2" />
          {{ branchPlace.internalName }}
        </router-link>
      </li>
    </template>
  </ul>
</template>

<script>
import { defineComponent } from 'vue'
import branchPlaceApi from '../../services/branches/branch-place.api'

export default defineComponent({
  data() {
    return {
      branchPlaces: [],
      loading: true
    }
  },
  mounted() {
    branchPlaceApi.getListAll(1, 100).then(
      response => {
        this.branchPlaces = response.data.data
        this.loading = false
      },
      error => {
        console.log(error)
        this.loading = false
      }
    )
  },
  props: {
    selectedBranchPlaces: {
      type: Array,
      default: () => []
    }
  }
})
</script>
